
const AuthError = () => {
    
    return(
        <h3 className="text-center p-10"><br></br>Auth Error</h3>
    )

}

export default AuthError